module.exports = __webpack_public_path__ + "static/media/TopScorerComponent_elCertificate2_624414.be9f02be.png";